export default __webpack_public_path__ + "static/media/image7.f40d674a.png";